import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FRAMETYPE = function (state, payload) {
  state.frameType = payload
}
mutations.INIT_PDT = function (state, payload) {
  state.rows = payload
  state.row = null
}
mutations.INIT_FRAME = function (state, payload) {
  state.rows_frame = payload
  state.row_frame = null
}
mutations.DO_EDIT = function (state, payload) {
  state.row = payload
}
mutations.CAT_OPTIONS = function (state, payload) {
  state.cat_options = payload
}
mutations.FRAME_TYPE_OPTIONS = function (state, payload) {
  state.frame_type_options = payload
}
mutations.ROWSEXCEPTID = function (state, payload) {
  state.rows_except_id = payload
}
mutations.RESET_RELATE = function (state, payload) {
  state.rows_except_id = payload
}

const state = {
  rows: [],
  row: null,
  condition: {},
  cat_options: [],
  rows_except_id: [],
  rows_frame: [],
  rows_frame_except_id: [],
  frame_type_options: []
}

const actions = {
  init: ({ commit, state }, condition) => {
    const ctx = {
      data: {
        init_pdt: { api: 'P0101ProductService.doSearch', input: { key: 'PDT' } },
        init_frame: { api: 'P0101ProductService.doSearch', input: { key: 'FR' } },
        catOptions: { api: 'P0102ProductCategoryService.getSelectbox' },
        frameType: { api: 'M0405FrameTypeService.getSelectbox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('INIT_PDT', data.init_pdt.output)
        commit('INIT_FRAME', data.init_frame.output)
        commit('CAT_OPTIONS', data.catOptions.output)
        commit('FRAME_TYPE_OPTIONS', data.frameType.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'P0101ProductService.searchDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchRelate: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { searchAll: { api: 'P0101ProductService.searchRelate', input: condition } } })
      .then((data) => {
        commit('ROWSEXCEPTID', data.searchAll.output)
      })
  },
  doFilterProduct: ({ commit, state }, condition) => {
    return client.postData({ data: { doFilterProduct: { api: 'P0101ProductService.doSearch', input: condition } }
    })
      .then((data) => {
        commit('FIND_ALL', data.doFilterProduct.output)
      })
  },
  add: ({ commit, state }, row) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null,
        is_publish: 1,
        files: [],
        key: row.key,
        colors: []
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'P0101ProductService.doEdit', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('DO_EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'P0101ProductService.doDelete', input: row } } })
      .then((data) => {
        commit('EDIT', null)
        commit('FIND_ALL', data.delete.output)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'P0101ProductService.doSave', input: row } } })
      .then((data) => {
        commit('INIT_PDT', data.save.output.pdt)
        commit('INIT_FRAME', data.save.output.frame)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
